import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import ApiService from '@/services/ApiService';

import { EditUserRequest, ResetUserPasswordRequest, User, UserRealmIdRequest } from '@/models/BenutzerModels';

export const useBenutzerStore: any = defineStore('benutzerStore', () => {
  const commonStore = useCommonStore();

  //#region Users
  const users = ref<User[]>([]);
  const user = ref<User | null>(null);

  async function getRealmUserById(data: UserRealmIdRequest) {
    commonStore.setStatus({ ...commonStore.status, getBenutzerLoading: true, benutzerErrorMsg: '' });

    return ApiService.getKeycloakRealmUserById(data)
      .then((res) => {
        const data: User = res.data;

        user.value = data;
      })
      .catch((err) => {
        commonStore.status.benutzerErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.getBenutzerLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  function resetUser() {
    user.value = null;
  }

  async function getAllRealmUsers(realm: string) {
    commonStore.setStatus({ ...commonStore.status, getBenutzerLoading: true, benutzerErrorMsg: '' });

    return ApiService.getAllKeycloakRealmUsers(realm)
      .then((res) => {
        const data: User[] = res.data;

        users.value = data;
      })
      .catch((err) => {
        commonStore.status.benutzerErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.getBenutzerLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function createRealmUser(data: EditUserRequest) {
    commonStore.setStatus({ ...commonStore.status, createBenutzerLoading: true, benutzerErrorMsg: '' });

    return ApiService.createKeycloakRealmUser(data)
      .then((_res) => {})
      .catch((err) => {
        commonStore.status.benutzerErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.createBenutzerLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function updateRealmUser(data: EditUserRequest) {
    commonStore.setStatus({ ...commonStore.status, updateBenutzerLoading: true, benutzerErrorMsg: '' });

    return ApiService.updateKeycloakRealmUser(data)
      .then((_res) => {})
      .catch((err) => {
        commonStore.status.benutzerErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.updateBenutzerLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function resetRealmUserPassword(data: ResetUserPasswordRequest) {
    commonStore.setStatus({ ...commonStore.status, updateBenutzerLoading: true, benutzerErrorMsg: '' });

    return ApiService.resetKeycloakRealmUserPassword(data)
      .then((_res) => {})
      .catch((err) => {
        commonStore.status.benutzerErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.updateBenutzerLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function deleteRealmUser(data: UserRealmIdRequest) {
    commonStore.setStatus({ ...commonStore.status, deleteBenutzerLoading: true, benutzerErrorMsg: '' });

    return ApiService.deleteKeycloakRealmUser(data)
      .then((_res) => {
        user.value = null;
        users.value = users.value.filter((u) => u.id !== data.id);
      })
      .catch((err) => {
        commonStore.status.benutzerErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.deleteBenutzerLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }
  //#endregion

  return {
    users,
    user,
    getAllRealmUsers,
    getRealmUserById,
    resetUser,
    createRealmUser,
    updateRealmUser,
    resetRealmUserPassword,
    deleteRealmUser,
  };
});
